import React from "react";

// todo: implement
export default function CourseNotFound() {
    return <div>CourseNotFound</div>;
}
